import React from 'react'

import { Dialog } from 'primereact/dialog'
import DialogFooter from '../../dialogFooter'
import InputChooseContaBancaria from '../../conciliacaoBancaria/inputChooseContaBancaria'
import { InputTextarea } from 'primereact/inputtextarea'
import ConstantsUtil from '../../../context/constantsUtil'
import ProvisaoService from '../../../app/service/contasAPagar/provisaoService'
import HandleErrorService from '../../../app/service/handleErrorService'
import AuthService from '../../../app/service/authService'

class InformarDadosPagamentoDialog extends React.Component {

    constructor(){
        super()
        this.inputTextObservacaoRef = React.createRef()
        this.provisaoService = new ProvisaoService();
    }

    state = {

        selectedContaBancaria: '',
        selectedContaBancariaLabel: '',

        inputContaBancariaErrorClass: '',
        // errorContaBancariaLabelMessage: '',

    }

    handleSelectionContaBancariaChange = async (selectedContaBancaria, selectedContaBancariaLabel) => {
        // console.log("selectedContaBancaria: ", selectedContaBancaria)
        // console.log("selectedContaBancariaLabel: ", selectedContaBancariaLabel)
        this.setState({
            selectedContaBancaria,
            selectedContaBancariaLabel
        })
    }

    hideDialog = () => {
        this.setState({
            selectedContaBancaria: '',
            selectedContaBancariaLabel: '',
        })
        this.props.hideDialog()
    }

    checkData = () => {

        let check = true

        if(!this.state.selectedContaBancaria){
            this.setState({inputContaBancariaErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        return check

    }

    resetView = () => {
        this.setState({
            inputContaBancariaErrorClass: '',
        })
    }

    callSave = () => {

        this.resetView()

        if(this.checkData()){
            this.save()
        }
    }

    save = () => {
        // console.log("contaBancaria: ", this.state.selectedContaBancaria)
        // console.log("parcelasInformarPagamentoIdList: ", this.props.parcelasInformarPagamentoIdList)
        // console.log("obs: ", this.inputTextObservacaoRef.current.value)

        let obj = {
            idParcelaProvisaoList: this.props.parcelasInformarPagamentoIdList,
            idContaBancaria: this.state.selectedContaBancaria.id,
            observacao: this.inputTextObservacaoRef.current.value
        }

        AuthService.startBlockUi()
        this.provisaoService.informarPagamento(obj)
        .then(response => {
            this.hideDialog()
            this.props.onSave()
        }).catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })

    }

    render(){

        const renderChooseContaBancariaPagamento = () => {
            return (
                <InputChooseContaBancaria
                    // invisible
                    excludeAplicacaoFinanceira
                    excludeInativas
                    forceChooseContaBancaria
                    selectedContaBancariaLabel={this.state.selectedContaBancariaLabel}
                    handleSelectionContaBancariaChange={this.handleSelectionContaBancariaChange}
                    inputContaBancariaErrorClass={this.state.inputContaBancariaErrorClass}
                    noHTMLFormat
                />                
            )
        }

        const footer = (
            <DialogFooter save = {this.callSave} hideDialog = {this.hideDialog} disabled={this.props.disabled}/>
        )

        return(

            <Dialog
                header={"Informe os dados de pagamento"}
                visible={this.props.visible} style={{ width: '90%' }}
                modal
                className="p-fluid"
                footer={footer}
                onHide={() => this.hideDialog(true)}
            >

                {renderChooseContaBancariaPagamento()}

                <div 
                    style={{marginTop: '1rem'}}
                >
                    <InputTextarea
                        ref={this.inputTextObservacaoRef}
                        rows={3} cols={100}
                        autoResize
                        placeholder={"Escreva uma observação (Opcional)"}
                    />
                </div>           

            </Dialog>

        )
    }

}

export default InformarDadosPagamentoDialog